// extracted by mini-css-extract-plugin
export default {"gif":"l_V","gif--wrapped":"l_W"};